<template>
  <div class="tw-flex tw-justify-center tw-items-cente">
    <div
      class="log tw-bg-eko-dark md:tw-w-2/5 md:tw-flex tw-hidden tw-p-4 tw-items-center tw-justify-center"
    >
      <div>
        <img
          class="tw-mx-auto"
          src="https://res.cloudinary.com/dldd8ucby/image/upload/v1580808183/Eko%20Carbon/logo_2.png"
        />
        <p class="tw-text-white tw-text-center tw-font-bold tw-text-xl">
          Let’s get you logged in
        </p>
        <p class="tw-text-white tw-text-center tw-font-bold">
          Trade Carbon easily
        </p>
      </div>
    </div>
    <div
      class="tw-min-h-screen tw-bg-eko-dark md:tw-bg-white md:tw-w-3/5 tw-w-full tw-flex tw-items-center tw-justify-center"
    >
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      data: {},
      loading: false,
      error: false,
      errors: {},
      error_msg: "",
      FB: null
    };
  },
  mounted() {
    let user = JSON.parse(localStorage.getItem("eko-carbon-user"));
    let token = localStorage.getItem("eko-carbon-token");
    if (user && token) {
      switch (user.userType) {
        case "lister":
          this.$router.push("/lister");
          break;
        case "offsetter":
          this.$router.push("/offsetter");
          break;
        case "admin":
          this.$router.push("/admin/projects");
          break;
      }
    }
  },
  methods: {
    submit() {
      this.error = false;
      this.error_msg = "";
      this.loading = false;
      this.success = false;
      this.success_msg = "";
      this.errors = {};
      let deny = false;
      if (!this.data.email) {
        this.errors.email = true;
        deny = true;
      }
      if (!this.data.password) {
        this.errors.password = true;
        deny = true;
      }
      if (deny) {
        return;
      }
      const self = this;
      self.loading = true;
      axios
        .post(`https://idea-app-2.herokuapp.com/user-login`, this.data)
        .then(response => {
          self.loading = false;
          self.success = true;
          this.$swal("Success!", "Login successfully!", "success");
          localStorage.setItem("idea-token", response.data.response.data.token);
          localStorage.setItem(
            "idea-user",
            JSON.stringify(response.data.response.data.user)
          );
          this.data = {};
          this.$router.push("/me/ideas");
        })
        .catch(error => {
          self.loading = false;
          self.error = true;
          self.$swal("Error!", "Invalid Login details", "error");
          console.log(error);
        });
    }
  }
};
</script>

<style scoped>
.log {
  min-height: 100vh;
  overflow: auto;
}
.my-img {
  width: 30%;
  height: 30%;
  margin: auto;
}
</style>
